module.exports = __webpack_public_path__ + "img/store-settings.6194b723.svg";